import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import moment from "moment";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Button from "@material-ui/core/Button/Button";
import ClearAll from "@material-ui/icons/ClearAll";
import FilterListIcon from "@material-ui/icons/FilterList";
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import TablePagination from "@material-ui/core/TablePagination";
import {MOBILE_TABLE_VIEW_AMOUNT} from "../../helpers/constants";
import {scrollToElement} from "../../helpers/functions";
import SortCriteriaForm from './sortCriteriaForm';
import _ from "lodash";

const styles = theme => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  summaryContent: {
    flexWrap: 'wrap'
  }
});

class CriteriaListMobileView extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      expanded: null,
    };

    this.criteriaMobileListRef = React.createRef();

  }

  componentDidMount(){
    this.props._changeLocalState({
      key: 'rowsPerPage',
      value: MOBILE_TABLE_VIEW_AMOUNT
    })
  }

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render() {
    const { classes, criteria, handleChangePage, handleChangeRowsPerPage, page, rowsPerPage } = this.props;
    const { expanded } = this.state;

    return (
      <div className={classes.root} ref={this.criteriaMobileListRef} >
        <Typography variant="h6" id="tableTitle">
          Criteria
        </Typography>
        <div className={''}>
         <Button color="secondary" style={{paddingLeft: 0}} className={classes.button} onClick={this.props.clearFilters}>
           Clear filters
           <ClearAll  className={'ml-1'}/>
         </Button>
         <Button
           color="primary"
           style={{paddingLeft: 0}}
           className={classes.button}
           onClick={this.props.openFilterModal}
         >
           Filter list
         <FilterListIcon className={'ml-1'}/>
         </Button>
       </div>
        <SortCriteriaForm
          {...this.props}
          initialValues={{sortBy: 'createdDate', sortOrder: 'desc'}}
        />
        {
          _.orderBy(criteria, item => {
            if(this.props.mobileViewSortBy === 'category') {return item.category.name}
            if(this.props.mobileViewSortBy === 'department') {return item.department.name}
            if(this.props.mobileViewSortBy === 'pillar') {return item.category.pillar.name}
            return item[this.props.mobileViewSortBy]
          }, this.props.mobileViewSortOrder)
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map(criterion => {
              return (
              <ExpansionPanel
                key={criterion.id}
                expanded={expanded === criterion.id}
                onChange={this.handleChange(criterion.id)}
              >
                <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} classes={{content: classes.summaryContent}}>
                  <Typography className={classes.heading}>{criterion.name}</Typography>
                  <Typography className={classes.secondaryHeading}>
                    {moment(criterion.createdDate).format('DD/MM/YYYY HH:mm:ss')}
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <Table >
                    <TableBody>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Id'}</TableCell>
                        <TableCell>{criterion.id}</TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Code'}</TableCell>
                        <TableCell>{criterion.code}</TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Εξάμηνη βαρύτητα'}</TableCell>
                        <TableCell>{criterion.weightOld}</TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Βαρύτητα νέων καταστημάτων'}</TableCell>
                        <TableCell>{criterion.weightNew}</TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Βαρύτητα υφιστάμενων καταστημάτων'}</TableCell>
                        <TableCell>{criterion.weightNewComing}</TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Category'}</TableCell>
                        <TableCell>{criterion.category.name}</TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Department'}</TableCell>
                        <TableCell>{criterion.department.name}</TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Pylon'}</TableCell>
                        <TableCell>{criterion.category.pillar.name}</TableCell>
                      </TableRow>
                      <TableRow >
                        <TableCell  component="th" scope="row">{'Created Date'}</TableCell>
                        <TableCell>{moment(criterion.createdDate).format('DD/MM/YYYY HH:mm:ss')}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </ExpansionPanelDetails>
                <ExpansionPanelActions>
                  <Button
                    size="small"
                    onClick={() => this.props._openDeleteModal(criterion.id)}
                  >
                    {'Delete'}
                  </Button>
                  <Button
                    size="small"
                    color="primary"
                    onClick={() => this.props.history.push('/criterion/' + criterion.id)}
                  >
                    {'Edit'}
                  </Button>
                </ExpansionPanelActions>
              </ExpansionPanel>
            )
          })
        }
        <TablePagination
          classes={
            {
              root: classes.pager,
              toolbar: classes.pagerToolbar
            }
          }
          rowsPerPageOptions={[]}
          labelRowsPerPage={''}
          component="div"
          count={criteria.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            'aria-label': 'Previous Page',
          }}
          nextIconButtonProps={{
            'aria-label': 'Next Page',
          }}
          onChangePage={(evt, page) => {
            scrollToElement(this.criteriaMobileListRef.current);
            handleChangePage(evt, page)
          }}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </div>
    );
  }
}

CriteriaListMobileView.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CriteriaListMobileView);



// WEBPACK FOOTER //
// ./src/components/criteria/criteriaListMobileView.js